import React, { useState } from 'react'
import Timeline from '../../Mantine/Timeline'
import Botao from '../../Mantine/Botao'
import Group from '../../Mantine/Group'
import Divider from '../../Mantine/Divider'
import LineSkeleton from '../../Mantine/Skeleton/line'
import * as S from './styles'
import { format, parseISO } from 'date-fns'
import { useQuery } from 'react-query'

import { OrdersService } from '../../../services/http/orders.service'
import { useGlobal } from '../../../stores/useGlobal'

import iconWaiting from '../../../icones/iconesVersaoVerde/waiting.svg'
import Icone from '../../Icone'

const ICONS = {
  FC: 'circleDocument',
  PO: 'misc',
  RO: 'vehicle',
  DO: 'circleArrows',
  OEC: 'circleBox',
  BDE: 'circleCheck',
  BDI: 'circleCheck',
  LDI: 'lockerStroke'
}

let active = 0
let heightPerItem = 90

export default function Rastreamento({ close, orderID }) {
  const { setIsLoadingGlobal } = useGlobal()

  const [tracking, setTracking] = useState(null)
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(false)

  const { getCourierTracking } = OrdersService

  useQuery(
    [`courierTracking/${orderID}`],
    async () => {
      try {
        setIsLoadingGlobal(true)
        setLoading(true)
        const track = await getCourierTracking(orderID)
        const objeto = track?.objetos?.[0]
        setTracking(objeto)

        if (!objeto?.eventos || objeto?.eventos?.length === 0) {
          active = -1 // para não setar a etapa como ativa
          heightPerItem = 120
        }
        setEvents(objeto?.eventos || [])
      } finally {
        setIsLoadingGlobal(false)
        setLoading(false)
      }
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false
    }
  )

  if (loading) {
    return (
      <S.Container>
        <Divider />
        <LineSkeleton height={305} visible />
        <Divider />
        <Group position="center">
          <Botao label="Fechar" onClick={close} />
        </Group>
      </S.Container>
    )
  }

  if (!tracking) return null

  const code = tracking.codObjeto
  const formatCode = `${code.slice(0, 2)} ${code.slice(2, 5)} ${code.slice(5, 8)} ${code.slice(8, 11)} ${code.slice(11)}`

  const formatEvents =
    events?.length === 0
      ? [
          {
            title: 'Aguardando dados',
            description:
              'Ainda não há informações de rastreamento disponíveis para sua encomenda. Por favor, tente novamente mais tarde.',
            icon: iconWaiting,
            info: format(new Date(), 'dd/MM/yyyy HH:mm')
          }
        ]
      : events.map((event, idx) => {
          const isFirst = idx === 0
          const formatted = format(
            parseISO(event.dtHrCriado),
            'dd/MM/yyyy  HH:mm'
          )
          const unidade = event?.unidade
          const unidadeDestino = event?.unidadeDestino

          const description = ['RO', 'DO'].includes(event.codigo) ? (
            <>
              <div>
                de {unidade.tipo}, {unidade.endereco.cidade} -{' '}
                {unidade.endereco.uf}
              </div>
              <div>
                para {unidadeDestino.tipo}, {unidadeDestino.endereco.cidade} -{' '}
                {unidadeDestino.endereco.uf}
              </div>
            </>
          ) : event.codigo === 'FC' ? (
            <>Brasil</>
          ) : (
            `${event.unidade?.endereco?.cidade} - ${event.unidade?.endereco?.uf}`
          )

          const iconName = ICONS[event.codigo]
          const iconComponent = iconName ? (
            <Icone
              width={iconName === 'circleArrows' ? '18px' : '20px'}
              height={iconName === 'circleArrows' ? '18px' : '20px'}
              nome={iconName}
              color={isFirst ? 'default' : 'primary'}
            />
          ) : null

          return {
            title: event.descricao || '',
            description: description || '',
            line: isFirst ? undefined : 'dashed',
            icon: iconComponent,
            info: formatted || ''
          }
        })

  return (
    <S.Container>
      <Divider />
      <S.Code className="header">Código: {formatCode}</S.Code>
      <Divider />
      <Timeline
        active={active}
        events={formatEvents}
        heightPerItem={heightPerItem}
      />
      <Group position="center">
        <Botao label="Fechar" onClick={close} />
      </Group>
    </S.Container>
  )
}
